import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import routes from "../../content/generated/route-manifest.json";
import styles from "./SourceClonePage.module.css";
import { attachSourceCloneInteractions, sourceInteractionStyles } from "./sourceCloneInteractions";
import { applySourceColorRepairs } from "./sourceColorRepair";
import { resolvePublicUrl } from "../../platform/public-url";

type RouteRecord = Readonly<{ id: string; path: string; title: string }>;
const entries = new Map((routes as RouteRecord[]).map((entry) => [entry.path, { ...entry, file: `/source-pages/${entry.id}.html`, sourceUrl: `https://pedemup.org${entry.path}` }]));
const knownPaths = new Set(entries.keys());

export function SourceClonePage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const host = useRef<HTMLDivElement>(null);
  const [markup, setMarkup] = useState<string>();
  const entry = entries.get(pathname);

  useEffect(() => {
    let active = true;
    setMarkup(undefined);
    if (!entry?.file) return () => { active = false; };
    fetch(resolvePublicUrl(entry.file)).then((response) => {
      if (!response.ok) throw new Error(`Source page request failed: ${response.status}`);
      return response.text();
    }).then((html) => { if (active) setMarkup(html); }).catch(() => { if (active) setMarkup(""); });
    return () => { active = false; };
  }, [entry]);

  useEffect(() => {
    if (!host.current || markup === undefined) return;
    const shadow = host.current.shadowRoot ?? host.current.attachShadow({ mode: "open" });
    shadow.innerHTML = "";
    const stylesheet = document.createElement("link");
    stylesheet.rel = "stylesheet";
    stylesheet.href = resolvePublicUrl("/source-pages/original.css");
    const viewport = document.createElement("div");
    viewport.className = "source-page-viewport";
    viewport.innerHTML = markup;
    viewport.querySelectorAll<HTMLImageElement>("img[src]").forEach((image) => {
      image.src = resolvePublicUrl(image.getAttribute("src") ?? "");
    });
    const colorRepairs = applySourceColorRepairs(viewport);
    viewport.dataset.colorRepairs = String(colorRepairs.gradients + colorRepairs.backgrounds + colorRepairs.text + colorRepairs.borders);
    const interactionStyles = document.createElement("style");
    interactionStyles.textContent = sourceInteractionStyles;
    shadow.append(stylesheet, interactionStyles, viewport);
    return attachSourceCloneInteractions(shadow, navigate, knownPaths);
  }, [markup, navigate]);

  useEffect(() => { if (entry) document.title = `${entry.title} | PedEmUP`; }, [entry]);

  if (!entry) return <section className={styles.status}><h1>İçerik bulunamadı</h1><Link to="/">Ana sayfaya dön</Link></section>;
  if (markup === undefined) return <section className={styles.status} role="status">İçerik yükleniyor…</section>;
  if (!markup) return <section className={styles.status}><h1>İçerik yüklenemedi</h1><Link to={entry.sourceUrl}>Kaynak sayfayı aç</Link></section>;
  return <div className={styles.host} ref={host} data-source-path={pathname} />;
}
